import * as Immutable from 'immutable';
import {
  GET_ACCOUNTTYPE_ABORTED,
  GET_ACCOUNTTYPE_REQUESTED,
  GET_ACCOUNTTYPE_COMPLETED,
  GET_ACCOUNTTYPE_FAILED,
  RESET_ACCOUNTTYPE_REQUESTED,
  RESET_ACCOUNTTYPE_COMPLETED,
} from '../../actions/accounttype/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: null,
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACCOUNTTYPE_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_ACCOUNTTYPE_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_ACCOUNTTYPE_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_ACCOUNTTYPE_FAILED:
      return state.set('error', action.payload);
    case RESET_ACCOUNTTYPE_REQUESTED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', true)
        .set('gotdata', true);

    case RESET_ACCOUNTTYPE_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', false)
        .set('data', null)
        .set('gotdata', true);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
